<template>
  <div class="main-content">

    <div>
      <pulse-loader :loading="loading" :color="color" class="text-center"/>
    </div>

    <div v-if="!loading">
      <div class="row" v-if="isTaksToAction()">
        <div class="col-md-12" v-for="(taskSet, userId) in tasks" :key="userId">
          <div v-if="taskSet.tasks.length" class="card">
            <div class="card-header">
              <h6>{{ taskSet.user.name }}</h6>
            </div>
            <div class="card-body">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th></th>
                  <th>ID</th>
                  <th>PREP ID</th>
                  <th>Препарат</th>
                  <th>количество</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(task, index) in taskSet.tasks">
                  <tr v-for="(prep, index2) in task.preps">
                    <td>{{ index2 + 1 }}</td>
                    <td>{{ task.taskId }}</td>
                    <td>{{ prep.id }}</td>
                    <td>{{ prep.name }}</td>
                    <td>{{ prep.to_move }}</td>
                    <td>
                      <button type="button" @click="updateQuantity($event, task.taskId)" class="btn btn-sm btn-success">
                        Выполнено
                      </button>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body text-center">
              <h5>Нет задач для обновления рюкзаков</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import api from '@/api'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  components: {
    PulseLoader
  },
  data() {
    return {
      tasks: null,
      loading: true,
      color: '#007dcc',
      Toast: this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      }),
    }
  },
  mounted() {
    this.getTasks();
  },
  methods: {
    isTaksToAction() {
      let found = false;
      Object.keys(this.tasks).forEach((key) => {
        if (this.tasks[key].tasks.length) found = true;
      });
      return found;
    },
    removeTask(taskId) {
      Object.keys(this.tasks).forEach((key) => {
        this.tasks[key].tasks = this.tasks[key].tasks.filter((t) => t.taskId != taskId);
      });
    },
    async updateQuantity(e, taskId) {
      e.target.disabled = true;
      console.log(taskId);
      let {data} = await api.store('/runners/storage/updateBackPack', {
        task_id: taskId
      });

      if (data.success) {
        this.removeTask(taskId);
        this.Toast.fire({
          type: 'success',
          title: 'Сохранено'
        })
      } else {
        this.Toast.fire({
          type: 'warning',
          title: 'Ошибка ' + data.message
        })
      }
      e.target.disabled = false;
    },
    async getTasks() {
      let {data} = await api.index('/runners/storage/getTasks');
      this.tasks = data.tasks;
      this.loading = false;
    }
  }
}

</script>
